import { CSSObject, Theme } from '@mui/material/styles';

const activeItemMixin = (theme: Theme): CSSObject => ({
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.default,
  '&:after': {
    content: '" "',
    position: 'absolute',
    width: '4px',
    height: '100%',
    backgroundColor: theme.palette.primary.main,
    borderTopRightRadius: `${theme.shape.borderRadius}px`,
    borderBottomRightRadius: `${theme.shape.borderRadius}px`,
    marginLeft: -1.5,
  },
});

const activeLinkItemMixin = (theme: Theme): CSSObject => ({
  py: 0.25,
  pl: 1.5,
  pr: 2,
  '& .MuiListItemIcon-root': {
    color: theme.palette.text.secondary,
    padding: 1,
  },
  '&:hover, &:focus, &.Mui-focusVisible': {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    '& .MuiListItemIcon-root': { color: theme.palette.primary.main },
  },
  '&.active': {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.default,
    '& .MuiListItemIcon-root': { color: theme.palette.primary.main },
    ...activeItemMixin(theme),
  },
});

export { activeItemMixin, activeLinkItemMixin };
